import { Link } from 'react-router-dom'

import BrandButton from 'components/contentspace/portal/BrandButton'
import { KitSize } from 'components/uiKit/KitTypes'
import { Typography } from 'components/uiKit/Typography'
import { usePortalBasePath } from 'routes/portal/ContentSpacePublic/hooks/usePortalParams'
import { testPropsEl } from 'utils/test/qaData'

import * as s from './NotFoundPortal.module.scss'

interface IPortalConfig {
  preloader?: { logoUrl?: string | null }
}

const getLogoUrl = (): string | null => {
  const cfg = (window as unknown as { __PORTAL_CONFIG__?: IPortalConfig }).__PORTAL_CONFIG__
  return cfg?.preloader?.logoUrl ?? null
}

const NotFoundPortal: React.FC = () => {
  const logoUrl = getLogoUrl()
  const basePath = usePortalBasePath()
  const homePath = basePath || '/'

  return (
    <div className={s.root} {...testPropsEl('notFoundPortal', { name: 'root' })}>
      <div className={s.content}>
        {logoUrl ? <img alt='Portal logo' className={s.logo} src={logoUrl} /> : null}
        <Typography
          color='var(--brand-primaryColor)'
          indents={{ marginBottom: 16 }}
          size={96}
          styleType='heading'
          weight='bold'
        >
          404
        </Typography>
        <Typography
          indents={{ marginBottom: 8 }}
          size={KitSize.L}
          styleType='heading'
          weight='semi'
        >
          Page not found
        </Typography>
        <Typography indents={{ marginBottom: 24 }} styleType='hint'>
          The page you are looking for does not exist or has been moved.
        </Typography>
        <Link to={homePath}>
          <BrandButton name='notFoundPortalBack'>Back to portal</BrandButton>
        </Link>
      </div>
    </div>
  )
}

export default NotFoundPortal
